import ListSection from "../../../../Cards/ListSection";
import Itinerary from "../Itinerary";

interface Props {
  data: {
    itinerary: any;
    remarks: Array<string>;
    cancellationPolicy: Array<string>;
  };
}

export default function GeneralInformation({
  data: { itinerary, remarks, cancellationPolicy },
}: Props) {
  return (
    <>
      <Itinerary data={{ itinerary }} />
      {remarks && (
        <ListSection
          style={{ marginTop: 30, marginBottom: 30 }}
          title="Remarks"
          items={remarks}
        />
      )}
      <ListSection
        style={{ marginTop: 30, marginBottom: 30 }}
        title="Cancel Policy"
        items={cancellationPolicy}
      />
    </>
  );
}
